/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Alpha_Status_ExportingInputs */



/**
* | output |
* | --- |
* | "Exporting video with alpha channel..." |
*
* @param {Video_Export_Alpha_Status_ExportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_status_exporting = /** @type {((inputs?: Video_Export_Alpha_Status_ExportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Status_ExportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation video avec canal alpha...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoexport mit Alphakanal...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione video con canale alfa...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео с альфа-каналом...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportando vídeo con canal alfa...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出带透明度通道的视频……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アルファ チャンネル付きのビデオをエクスポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अल्फा चैनल सहित वीडियो निर्यात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportando vídeo com canal alfa...")
	return /** @type {LocalizedString} */ ("Exporting video with alpha channel...")
});